"use strict";

import dispatcher from "./../../dispatcher";
import vehicleActivityStore from "./../../store/vehicleActivities";
import displayedDetailsStore from "./../../store/displayedDetails";
import openedDetailsStore from "./../../store/openedDetails";

import vehicleActivityUtils from "./../../utils/vehicleActivity";
import {positionToLatLng} from "./../../utils/geo";

import zIndex from "./zIndex";

import lang from "vwa/lang";

const ROUTE_START_END_MARKER = {
	zIndex: zIndex.ROUTE_START_END_MARKER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 4,
		fillOpacity: 1,
		fillColor: "red",
		strokeColor: "black",
		strokeOpacity: 0.5,
		strokeWeight: 2
	}
};

const HIGHLIGHTED_ROUTE_START_END_MARKER = {
	zIndex: zIndex.HIGHLIGHTED_ROUTE_START_END_MARKER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 4,
		fillOpacity: 1,
		fillColor: "#00ebff",
		strokeColor: "black",
		strokeOpacity: 0.5,
		strokeWeight: 2
	}
};

const ROUTE_POINTER_MARKER = {
	zIndex: zIndex.ROUTE_POINTER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 5,
		fillOpacity: 1,
		fillColor: "red",
		strokeColor: "red",
		strokeOpacity: 0.5,
		strokeWeight: 10
	}
};

const DEFAULT_POLY_OPTIONS = {
	strokeOpacity: 1.0,
	strokeWeight: 2,
	geodesic: true,
	zIndex: zIndex.ROUTE_DEFAULT
};

const DEFAULT_STROKE_OPTIONS = {
	strokeColor: "black",
	strokeOpacity: 0.5,
	strokeWeight: 5,
	geodesic: true,
	zIndex: zIndex.ROUTE_DEFAULT_STROKE
};

const SELECTED_POLY_OPTIONS = {
	strokeColor: "black",
	strokeOpacity: 1,
	strokeWeight: 7,
	geodesic: true,
	zIndex: zIndex.ROUTE_SECTION_SELECTED_STROKE
};

const TRANSPARENT_POLY_OPTIONS = {
	strokeOpacity: 0,
	strokeWeight: 7,
	geodesic: true,
	zIndex: zIndex.ROUTE_SECTION_TRANSPARENT
};

const HIGHLIGHTED_POLY_OPTIONS = {
	strokeColor: "#00ebff",
	strokeOpacity: 1.0,
	strokeWeight: 2,
	geodesic: true,
	zIndex: zIndex.ROUTE_SECTION_HIGHLIGHT,
	icons: [{
		icon: {path: 'M 8,0 -8,5 -8,-5 8,0 z',
						fillColor: "#00ebff",
						fillOpacity: 1,
						strokeColor: "black",
						strokeWeight: 1,
						scale: 1,
						rotation: -90},
		repeat: "100px",
		offset: "100%"
	}]
};

export default class VehicleActivityController{
	
	constructor(map){
		this.map = map;
		this.initActivities();
		this.setListeners();
	}
	
	initActivities(){
		this.activities = this.activities || {};
	}
	
	setListeners(){
		google.maps.event.addListener(this.map, "click", _ => this.handleMapClick());
		
 		vehicleActivityStore.on("insert", activityDescriptors => this.addActivities(activityDescriptors));
		vehicleActivityStore.on("remove", activityDescriptors => this.removeActivities(activityDescriptors));
		vehicleActivityStore.on("update", activityDescriptor => this.updateActivity(activityDescriptor.vehicle));
		displayedDetailsStore.on("change", detailsDescriptor => this.handleDetailsStoreUpdate(detailsDescriptor));
	}
	
	handleMapClick(){
		dispatcher.dispatch("selectVehicleActivityRoute", displayedDetailsStore.get() ? displayedDetailsStore.get().id : null, null, null);
	}

	handleDetailsStoreUpdate(detailsDescriptor){
		this.updateVisibilities();
		if(detailsDescriptor && openedDetailsStore.get(detailsDescriptor.id).activePage == "activity"){
			const activityDescriptor = vehicleActivityStore.get(detailsDescriptor.id);
			vehicleActivityUtils.focusOnVehicleActivity(detailsDescriptor.id);
		}
	}
	
	addActivities(activities){
		activities.forEach(activity => this.addActivity(activity.vehicle));
	}
	
	removeActivities(activities){
		activities.forEach(activity => this.removeActivity(activity.vehicle));
	}
	
	addActivity(vehicleId){
		this.removeActivity(vehicleId);
		
		window.poly = 0;
		
		const descriptor = vehicleActivityStore.get(vehicleId);
		if(!descriptor || descriptor.pending)
			return;
		
		this.activities[vehicleId] = {
			from: descriptor.from,
			to: descriptor.to,
			shapes: this.createShapes(vehicleId),
			selectedRoute: null,
			selectedPosition: null
		};
		
		this.updateVisibility(vehicleId);
	}
	
	removeActivity(vehicleId){
		const activity = this.activities[vehicleId];
		if(!activity)
			return;
		
		activity.shapes.forEach(shapeCollection => this.removeShapeCollection(shapeCollection));
		
		if(activity.selectedRoute && activity.selectedRoute.polyline){
			activity.selectedRoute.polyline.setMap(null);
		}
		
		delete this.activities[vehicleId];
	}
	
	existsActivity(vehicleId) {
		return !!this.activities[vehicleId];
	}
	
	wasChangedActivity(vehicleId) {
		const descriptor = vehicleActivityStore.get(vehicleId);
		if(!descriptor)
			return false;
		if(!this.existsActivity(vehicleId))
			return true;
		if(descriptor.from !== this.activities[vehicleId].from || descriptor.to !== this.activities[vehicleId].to)
			return true;
		return false;
	}
	
	updateActivity(vehicleId){
		if(this.wasChangedActivity(vehicleId)) {
			this.removeActivity(vehicleId);
			this.addActivity(vehicleId);
		}
		this.updateSelectedRoute(vehicleId);
		this.updateSelectedPosition(vehicleId);
		this.updateVisibility(vehicleId);
	}
	
	updateVisibilities() {
		for(let vehicleId in this.activities) {
			this.updateVisibility(vehicleId);
		}
	}
	
	updateVisibility(vehicleId) {
		
		const activity = this.activities[vehicleId];	
		const descriptor = vehicleActivityStore.get(vehicleId);
		
		if(!descriptor || !activity){
			return;
		}
		
		const canBeDisplayed = vehicleActivityUtils.getVisibilityOfActivity(vehicleId);
		
		if(activity.selectedRoute && activity.selectedRoute.polyline)
			activity.selectedRoute.polyline.setVisible(canBeDisplayed);
		
		(descriptor.sections || []).forEach((section, sectionIndex) => {
			const shapeCollection = activity.shapes[sectionIndex];
			if(!shapeCollection)
				return;
			const pinned = descriptor.pinnedSections[sectionIndex];
			const shouldBeDisplayed = canBeDisplayed && pinned;
			const highlighted = descriptor.highlightedSections[sectionIndex];
			
			//route előtérbe hozása, ha érinti a selected route-ot
			if(	activity.selectedRoute &&
				section.start.time.value < activity.selectedRoute.to && 
				section.end.time.value > activity.selectedRoute.from
			){
				shapeCollection.defaultPolylines.forEach(
					e => e.setOptions({zIndex: zIndex.ROUTE_SECTION_SELECTED})
				);
			}
			else if(shapeCollection.defaultPolylines[0].get("zIndex") != zIndex.ROUTE_DEFAULT){
				shapeCollection.defaultPolylines.forEach(
					e => e.setOptions({zIndex: zIndex.ROUTE_DEFAULT})
				);
			}
			
			if(shouldBeDisplayed != shapeCollection.defaultPolylines[0].getVisible()){
				shapeCollection.defaultPolylines.forEach(
					e => e.setVisible(shouldBeDisplayed)
				);
				shapeCollection.startMarker.setVisible(shouldBeDisplayed);
				shapeCollection.endMarker.setVisible(shouldBeDisplayed);
				shapeCollection.stroke.setVisible(canBeDisplayed && (pinned || highlighted));
				shapeCollection.transparent.setVisible(shouldBeDisplayed);
			}
			if(highlighted != shapeCollection.highlighted.getVisible() ){
				const isSectionHighlightedAndPinned = canBeDisplayed && (pinned && highlighted);
				shapeCollection.highlighted.setVisible(canBeDisplayed && highlighted);
				shapeCollection.highlightedStartMarker.setVisible(canBeDisplayed && highlighted);
				shapeCollection.highlightedEndMarker.setVisible(canBeDisplayed && highlighted);
				shapeCollection.stroke.setVisible(canBeDisplayed && (pinned || highlighted));
				shapeCollection.stroke.setOptions({zIndex: (isSectionHighlightedAndPinned ? zIndex.ROUTE_SECTION_HIGHLIGHTED_STROKE : zIndex.ROUTE_DEFAULT_STROKE)});
			}
		});
	}
	
	updateSelectedRoute(vehicleId){
		const activity = this.activities[vehicleId];
		const descriptor = vehicleActivityStore.get(vehicleId);
		
		if(!activity || !descriptor){
			return;
		}
		
		// ha nem változott a kezdő- és végpont,
		// akkor kilépünk
		if( activity.selectedRoute &&
			descriptor.selectedRoute && 
			descriptor.selectedRoute.from === activity.selectedRoute.from && 
			descriptor.selectedRoute.to === activity.selectedRoute.to)
		{
			return;
		}
		
		this.removeSelectedRouteStroke(vehicleId);
		
		// ha eltávolítottuk a selectiont,
		// akkor csak kitöröljük a hozzá tartozó shape-et
		if(!descriptor.selectedRoute || (descriptor.selectedRoute && descriptor.selectedRoute.from == null && descriptor.selectedRoute.to == null)) {
			return;
		}
		
		const path = vehicleActivityUtils.createPathFromInterval(vehicleId, descriptor.selectedRoute.from, descriptor.selectedRoute.to);
		
		activity.selectedRoute = {};
		activity.selectedRoute.from = descriptor.selectedRoute.from;
		activity.selectedRoute.to = descriptor.selectedRoute.to;
		
		if(path && path.length) {
			activity.selectedRoute.polyline = this.createSelectedRouteStroke(path);
		}
	}
	
	updateSelectedPosition(vehicleId) {
		const descriptor = vehicleActivityStore.get(vehicleId);
		const activity = this.activities[vehicleId];
		if(!activity)
			return;
		
		// ha nem változott, akkor kilépünk
		if(activity.selectedPosition && (descriptor.selectedPosition == activity.selectedPosition.time)) {
			return;
		}
		
		this.removeSelectedPositionMarker(descriptor.vehicle);
		
		if(!descriptor.selectedPosition) {
			return;
		}
			
		const latLng = vehicleActivityUtils.getLatLngOfVehicleRoutesByTime(vehicleId, descriptor.selectedPosition);
		
		if(latLng) {
			activity.selectedPosition = {};
			activity.selectedPosition.time = descriptor.selectedPosition;
			activity.selectedPosition.marker = this.createRoutePointerMarker(latLng);
		}
	}
	
	removeSelectedRouteStroke(vehicleId){
		if(this.activities[vehicleId].selectedRoute && this.activities[vehicleId].selectedRoute.polyline){
			this.activities[vehicleId].selectedRoute.polyline.setMap(null);
			delete this.activities[vehicleId].selectedRoute;
		}
	}
	
	removeSelectedPositionMarker(vehicleId){
		if(this.activities[vehicleId].selectedPosition){
			this.activities[vehicleId].selectedPosition.marker.setMap(null);
			delete this.activities[vehicleId].selectedPosition;
		}
	}
	
	createShapes(vehicleId) {
		const activity = vehicleActivityStore.get(vehicleId);
		if(!activity)
			return;
		
		return activity.routes.map((route, i) => {
			if(route.length && activity.sections[i].active) {
				return this.createShapeCollection(vehicleId, route, i);
			}
			else{
				return null;
			}
		});
	}
	
	createShapeCollection(vehicleId, route, index) {
		const path = route.map(positionToLatLng);
		
		return {
			startMarker:			this.createStartEndMarker(path[0]),
			highlightedStartMarker:	this.createHighlightedStartEndMarker(path[0]),
			endMarker:				this.createStartEndMarker(path[path.length-1]),
			highlightedEndMarker:	this.createHighlightedStartEndMarker(path[path.length-1]),
			defaultPolylines:		this.createDefaultSectionPolylines(route),
			highlighted:			this.createHighlightedSectionPolyline(path),
			stroke:					this.createDefaultSectionStroke(path),
			transparent:			this.createTransparentSectionPolyline(path, vehicleId, index, route[0].time, route[route.length-1].time)
		};
	}
	
	removeShapeCollection(shapeCollection) {
		if(!shapeCollection)
			return;
		
		shapeCollection.defaultPolylines.forEach(
			e => e.setMap(null)
		);
		shapeCollection.startMarker.setMap(null);
		shapeCollection.endMarker.setMap(null);
		shapeCollection.stroke.setMap(null);
		shapeCollection.transparent.setMap(null);
		shapeCollection.highlighted.setMap(null);
	}
	
	createDefaultSectionPolylines(route){
		const polylines = [];
		
		for(let i=1; i<route.length; i++){
			
			const currentColor = getColorFromSpeed(route[i].speed);
			const prevColor = getColorFromSpeed(route[i-1].speed);
	
			if(i > 2 && polylines.length > 1 && currentColor == prevColor){
				const prevPolyline = polylines[polylines.length-1];
				const newPath = prevPolyline.getPath();
				newPath.push(positionToLatLng(route[i]));
				prevPolyline.setOptions({path: newPath});
			}
			else{
				let polyline = new google.maps.Polyline({
					path: [positionToLatLng(route[i-1]), positionToLatLng(route[i])],
					map: this.map,
					strokeColor: getColorFromSpeed(route[i].speed)
				});
				polyline.setOptions(DEFAULT_POLY_OPTIONS);
				polylines.push(polyline);
			}
		}
		
		window.poly += polylines.length;
		
		return polylines;
	}
	
	createHighlightedSectionPolyline(path){
		const polyline = new google.maps.Polyline({
			path: path,
			map: this.map,
			visible: false
		});
		polyline.setOptions(HIGHLIGHTED_POLY_OPTIONS);
		return polyline;
	}
	
	createDefaultSectionStroke(path){
		const polyline = new google.maps.Polyline({
			path: path,
			map: this.map
		});
		polyline.setOptions(DEFAULT_STROKE_OPTIONS);
		return polyline;
	}
	
	handleTransparentSectionPolylineMouseover(evt, vehicleId, sectionIndex){
		dispatcher.dispatch("highlightVehicleActivitySection", vehicleId, [sectionIndex], true);
		
		const tooltipId = Date.now();		
		const tooltipLabel = lang.SECTION + " #" + vehicleActivityUtils.getActiveSectionNumberOfSectionIndex(vehicleId, sectionIndex); 
		dispatcher.dispatch("createTooltip", tooltipId, evt.latLng, tooltipLabel);
		
		google.maps.event.addListenerOnce(this.activities[vehicleId].shapes[sectionIndex].transparent, "mouseout", _ => {
			dispatcher.dispatch("removeTooltip", tooltipId);
		});

	}
	
	createTransparentSectionPolyline(path, vehicleId, sectionIndex, sectionStartTime, sectionEndTime){
		const polyline = new google.maps.Polyline({
			path: path,
			map: this.map
		});
		polyline.setOptions(TRANSPARENT_POLY_OPTIONS);
		google.maps.event.addListener(polyline, "mouseover", evt => this.handleTransparentSectionPolylineMouseover(evt, vehicleId, sectionIndex));
		google.maps.event.addListener(polyline, "mouseout",  evt => { dispatcher.dispatch("highlightVehicleActivitySection", vehicleId, [sectionIndex], false) });
		google.maps.event.addListener(polyline, "click", 	 evt => { 
			dispatcher.dispatch("selectVehicleActivityRoute", vehicleId, sectionStartTime, sectionEndTime);
			vehicleActivityUtils.focusOnVehicleActivity(vehicleId, sectionStartTime, sectionEndTime);
		});
		return polyline;
	}
	
	createStartEndMarker(position){
		const marker = new google.maps.Marker({
			map: this.map,
			position: position
		});
		marker.setOptions(ROUTE_START_END_MARKER);
		return marker;
	}
	
	createHighlightedStartEndMarker(position){
		const marker = new google.maps.Marker({
			map: this.map,
			position: position,
			visible: false
		});
		marker.setOptions(HIGHLIGHTED_ROUTE_START_END_MARKER);
		return marker;
	}
	
	createRoutePointerMarker(position){
		const marker = new google.maps.Marker({
			map: this.map,
			position: position
		});
		marker.setOptions(ROUTE_POINTER_MARKER);
		return marker;
	}
	
	createSelectedRouteStroke(path){
		const polyline = new google.maps.Polyline({
			path: path,
			map: this.map
		});
		polyline.setOptions(SELECTED_POLY_OPTIONS);
		return polyline;
	}
}

function getColorFromSpeed(speed){
	const lowerThresholdSpeed = 10;
	const upperThresholdSpeed = 100;
	
	if(speed >= upperThresholdSpeed)
		return "#00FF00";
	else if(speed <= lowerThresholdSpeed)
		return "#FF0000";
	
	const numberOfColorsByChannel = 2; //Árnyalatok száma csatornánként
	const colorDivider = Math.floor(255 / numberOfColorsByChannel);
	
	const medianSpeed = (lowerThresholdSpeed + upperThresholdSpeed)/2;
	const colorStep = 255 / (medianSpeed - lowerThresholdSpeed);
	
	let color = {r: 255, g: 255, b: 0};
	
	if(speed < medianSpeed){
		color.g = Math.round(((speed - lowerThresholdSpeed) * colorStep) / colorDivider) * colorDivider;
		color.g = Math.min(Math.ceil(color.g), 255);
	}
	else{
		color.r = Math.round((255 - (speed - medianSpeed) * colorStep) / colorDivider) * colorDivider;
		color.r = Math.min(Math.floor(color.r), 255);
	}
	
	const colorHex = "#" + hexLPad(color.r.toString(16)) + hexLPad(color.g.toString(16)) + hexLPad(color.b.toString(16)); 
	return colorHex;
}

function hexLPad(str) {
	if(str.length < 2){
		str = "0" + str;
	}
	return str;
}


// WEBPACK FOOTER //
// ./src/view/Map/VehicleActivityController.js